import React, { useEffect } from "react";
import styled from "styled-components";
import { motion } from "framer-motion";

const LegalPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  useEffect(() => {
    document.title = "Legal - Laureta Martini";
  }, []);

  return (
    <PageContainer
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
    >
      <ContentWrapper>
        <Sidebar>
          <nav>
            <a href="#impressum">Impressum</a>
            <a href="#datenschutz">Datenschutz</a>
            <a href="#agb">AGB</a>
          </nav>
        </Sidebar>

        <MainContent>
          {/* --- IMPRESSUM SECTION --- */}
          <Section id="impressum">
            <h1>Impressum</h1>
            <p>Angaben gemäß § 5 TMG</p>
            <div className="address-box">
              <strong>Laureta Martini</strong>
              <br />
              Inhaberin: Laureta
              <br />
              Friedrich Hebbel Straße 27,
              <br /> München 81369
            </div>

            <h3>Kontakt</h3>
            <p>
              <br />
              E-Mail: info@lauretamartini.com
            </p>

            <h3>Umsatzsteuer</h3>
            <p>
              Gemäß § 19 UStG wird keine Umsatzsteuer erhoben
              (Kleinunternehmerregelung).
            </p>

            <h3>Verantwortlich für den Inhalt nach § 55 Abs. 2 RStV</h3>
            <p>Laureta </p>
          </Section>

          <Divider />

          {/* --- DATENSCHUTZ SECTION --- */}
          <Section id="datenschutz">
            <h1>Datenschutzerklärung</h1>
            <p className="intro">
              Der Schutz deiner persönlichen Daten ist mir wichtig.
              Personenbezogene Daten werden vertraulich und entsprechend der
              gesetzlichen Datenschutzvorschriften behandelt.
            </p>

            <h3>1. Verantwortliche Stelle</h3>
            <p>Laureta Martini</p>

            <h3>2. Erhebung und Verarbeitung personenbezogener Daten</h3>
            <p>
              Personenbezogene Daten (z. B. Name, Telefonnummer, E-Mail-Adresse)
              werden nur erhoben, wenn du mir diese freiwillig mitteilst, z. B.:
            </p>
            <ul>
              <li>bei Terminbuchungen</li>
              <li>
                bei Kontaktaufnahme per WhatsApp, Instagram, Telefon oder E-Mail
              </li>
            </ul>
            <p>
              Diese Daten werden ausschließlich zur Terminverwaltung,
              Kundenkommunikation und Abrechnung verwendet.
            </p>

            <h3>3. Weitergabe von Daten</h3>
            <p>
              Eine Weitergabe deiner Daten an Dritte erfolgt nicht, außer wenn
              dies gesetzlich vorgeschrieben ist.
            </p>

            <h3>4. Speicherung und Löschung</h3>
            <p>
              Deine personenbezogenen Daten werden nur so lange gespeichert, wie
              es für die genannten Zwecke erforderlich ist oder gesetzliche
              Aufbewahrungspflichten bestehen.
            </p>

            <h3>5. Deine Rechte</h3>
            <p>Du hast jederzeit das Recht auf:</p>
            <ul>
              <li>Auskunft über deine gespeicherten Daten</li>
              <li>Berichtigung unrichtiger Daten</li>
              <li>
                Löschung deiner Daten, sofern keine gesetzlichen Pflichten
                entgegenstehen
              </li>
            </ul>

            <h3>6. Soziale Medien (Instagram, WhatsApp)</h3>
            <p>
              Die Kommunikation über soziale Medien erfolgt freiwillig. Bitte
              beachte, dass die jeweiligen Plattformen eigene
              Datenschutzrichtlinien haben, auf die ich keinen Einfluss habe.
            </p>
          </Section>

          <Divider />

          {/* --- AGB SECTION --- */}
          <Section id="agb">
            <h1>Allgemeine Geschäftsbedingungen (AGB)</h1>

            <h3>1. Geltungsbereich</h3>
            <p>
              Diese Bedingungen gelten für alle Dienstleistungen und Schulungen
              der Laureta Martini.
            </p>

            <h3>2. Terminbuchung & Stornierung</h3>
            <p>
              Gebuchte Termine sind verbindlich. Eine kostenfreie Stornierung
              oder Verschiebung ist bis zu 24 Stunden vor dem Termin möglich.
              Bei späteren Absagen oder Nichterscheinen behält sich die Academy
              vor, eine Ausfallgebühr in Rechnung zu stellen.
            </p>

            <h3>3. Academy-Teilnahme</h3>
            <p>
              Die Anmeldung zu Schulungen ist erst nach Zahlungseingang (oder
              vereinbarter Anzahlung) bestätigt. Schulungsunterlagen sind
              urheberrechtlich geschützt.
            </p>

            <h3>4. Haftung</h3>
            <p>
              Die Academy haftet nicht für gesundheitliche Komplikationen, die
              durch unvollständige Angaben des Kunden im Anamnesebogen
              entstehen.
            </p>
          </Section>
        </MainContent>
      </ContentWrapper>
    </PageContainer>
  );
};

export default LegalPage;

// --- STYLED COMPONENTS ---

const PageContainer = styled(motion.div)`
  background-color: #f9f8f6;
  min-height: 100vh;
  padding-top: 120px; /* Space for Navbar */
  padding-bottom: 100px;
  color: #5a5248;
  scroll-behavior: smooth;
`;

const ContentWrapper = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: 250px 1fr;
  gap: 60px;
  scroll-behavior: smooth;
  padding: 0 5%;

  @media (max-width: 900px) {
    grid-template-columns: 1fr;
  }
`;

const Sidebar = styled.aside`
  position: sticky;
  top: 150px;
  height: fit-content;
  scroll-behavior: smooth;
  nav {
    display: flex;
    flex-direction: column;
    gap: 15px;

    a {
      text-decoration: none;
      color: #857869;
      font-size: 0.9rem;
      text-transform: uppercase;
      letter-spacing: 1px;
      font-weight: 500;
      transition: color 0.3s ease;

      &:hover {
        color: #5a5248;
      }
    }
  }

  @media (max-width: 900px) {
    position: relative;
    top: 0;
    margin-bottom: 40px;
    nav {
      flex-direction: row;
      justify-content: space-around;
    }
  }
`;

const MainContent = styled.div`
  background: white;
  padding: 4rem;
  border-radius: 40px;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.03);
  border: 1px solid rgba(109, 99, 87, 0.1);
  scroll-behavior: smooth;

  @media (max-width: 600px) {
    padding: 2rem;
  }
`;

const Section = styled.section`
  scroll-margin-top: 150px;

  h1 {
    font-family: "Playfair Display", serif;
    font-size: 2.5rem;
    margin-bottom: 2rem;
  }

  h3 {
    margin-top: 2rem;
    margin-bottom: 0.5rem;
    font-size: 1.1rem;
    color: #5a5248;
  }

  p,
  li {
    line-height: 1.7;
    opacity: 0.85;
    font-size: 1rem;
    margin-bottom: 1rem;
  }

  ul {
    padding-left: 20px;
    margin-bottom: 1.5rem;
  }

  .address-box {
    background: #fdfcfb;
    padding: 20px;
    border-radius: 15px;
    border: 1px solid rgba(109, 99, 87, 0.1);
    margin-bottom: 2rem;
  }
`;

const Divider = styled.hr`
  border: none;
  border-top: 1px solid rgba(109, 99, 87, 0.1);
  margin: 4rem 0;
`;
